import $ from 'jquery';
import _ from 'underscore';
import io from 'socket.io-client';
import Backbone from 'backbone';

import 'jquery_cookie';

import CoachCollection from 'collections/coach_list';
import DomainCollection from 'collections/domains';
import ContactCollection from 'collections/contact';
import CoachhubUserModel from 'models/coachhub_user';
import CoachListView from 'views/coach_list';
import CoachDetailView from 'views/coach_detail';
import ContactListView from 'views/contact_list';
import CoachFiltersView from 'views/coach_filters';
import ProfileMessageView from 'views/profile_message';


export default Backbone.View.extend({
  initialize: function () {
    _.bindAll(this, 'render', 'initialize_ajax', 'initialize_conductor');

    this.initialize_ajax();

    // Get collections and models before rendering
    this.domains = new DomainCollection();
    this.coaches = new CoachCollection();
    this.contacts = new ContactCollection();
    this.coachhub_user = new CoachhubUserModel();
    $.when(this.domains.fetch({ cache: true, expires: 604800 }),
      this.coaches.fetch({ cache: true, expires: 86400 }),
      this.contacts.fetch(),
      this.coachhub_user.fetch()).then(this.render);

    // Retrieve the coachhub user information, use the user id to get a
    // conductor token, then subscribe to conductor events
    this.coachhub_user.fetch({ success: _.bind(function (model) {
      var params = '?user_id=' + model.get('id');
      $.get(window.Urls['conductor-token']() + params, this.initialize_conductor);
    }, this) });
  },

  render: function () {
    this.coach_list_el = $('#coach-list', this.$el);
    this.coach_detail_view = new CoachDetailView({
      el: $('#coach-detail', this.$el),
      coachhub: this
    });
    // Give the coach list a copy of the coaches collection so that any changes
    // made don't affect other views.
    this.coach_list_view = new CoachListView({
      el: this.coach_list_el,
      collection: this.coaches.clone(),
      coachhub: this
    });
    this.profile_message_view = new ProfileMessageView({
      el: $('#secondary-header > .container'),
      coachhub: this
    });
    new CoachFiltersView({ el: $('#filters', this.$el), coachhub: this });
    new ContactListView({ el: $('#contact-list', this.$el), coachhub: this });
  },

  initialize_ajax: function () {
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
      options = _.extend(options, {
        crossDomain: { crossDomain: true },
        xhrFields: { withCredentials: true },
        headers: { 'X-CSRFToken': $.cookie('coachhub_csrftoken') },
        complete: function (jqXHR_complete, status) {
          // Save the csrf token set by CoachHub so we can put it
          // in a request header later
          var csrf = jqXHR_complete.getResponseHeader('X-Csrf-Token');
          if (csrf) {
            $.cookie('coachhub_csrftoken', csrf);
          }
          // Run the original complete method, if it exists
          if (_.contains(_.keys(originalOptions), 'complete')) {
            originalOptions.complete(jqXHR_complete, status);
          }
        },
        error: function (jqXHR_error, status, error_thrown) {
          // If we have a forbidden error and this isn't a retry,
          // or a call to an api endpoint that is expected to give a 403
          // in some cases (permissions, messages), then reload the page
          // to force a reauthentication
          if (jqXHR_error.status == 403 &&
                          this.url.indexOf('reauth') == -1 &&
                          this.url.indexOf('permissions') == -1 &&
                          this.url.indexOf('messages') == -1) {
            $.removeCookie('coachhub_csrftoken', { path: '/' });
            window.location = window.location + '?reauth=true';
          } else {
            // Run the original error method if it exists
            if (_.contains(_.keys(originalOptions), 'error')) {
              originalOptions.error(jqXHR_error, status, error_thrown);
            }
          }
        }
      });
    });
  },

  initialize_conductor: function (resp) {
    var url = CONDUCTOR_URL;
    var token = resp.token;
    var self = this;
    if (url && token) {
      self.socket = io(url);
      self.socket.on('connect', function () {
        self.socket.emit('authenticate', token);
      });
      self.socket.on('authentication failed', function (data) {
        if (data && data.error && data.error.name === 'TokenExpiredError') {
          $.when($.get(CONDUCTOR_TOKEN_URL)).done(function (resp) {
            // Allow a full second (plus whatever time the XHR already took)
            // for the server disconnect (which always follows an
            // 'authentication failed') to be fully processed on both server
            // and client before we try to re-connect.
            window.setTimeout(function () {
              token = resp.token;
              self.socket.connect(url, { forceNew: true });
            }, 1000);
          });
        }
      });
      self.socket.on('authenticated', function () {
        var events = [
          'new-message',
          'coach-changed',
          'coaching-hours-changed',
          'coach-appointments-confirmed',
          'user-online',
          'user-offline'
        ];
        // Listen for incoming events
        _.each(events, function (conductor_event) {
          self.socket.on(conductor_event, function (data) {
            self.trigger(conductor_event, data);
          });
        });
      });
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/views/coachhub.js